<template>
  <el-dialog
    :show-close="false"
    :title="title"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    width="400px"
  >
    <slot></slot>
    <template v-slot:footer>
      <el-button @click="handleCloseDialog('notModify')">暂不修改</el-button>
      <el-button type="primary" @click="handleCloseDialog('toModify')"> 去修改 </el-button>
    </template>
  </el-dialog>
</template>
<script>
export default {
  name: 'Alert',
  props: {
    title: {
      type: String,
      default: '提示',
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogVisible: this.show,
    };
  },
  watch: {
    show(value) {
      this.dialogVisible = value;
    },
    dialogVisible(value) {
      if (!value) {
        this.$emit('update:show', value);
      }
    },
  },
  methods: {
    handleCloseDialog(type) {
      this.dialogVisible = false;
      this.$emit('close', type);
    },
    onClose() {
      this.$emit('close');
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .el-dialog {
    box-sizing: border-box;
    padding: 16px 24px 24px 24px;
  }
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 16px 0 24px 0;
  }
  .el-dialog__footer {
    padding: 0;
  }
  .el-dialog__title {
    font-size: 18px;
    font-family: PingFang SC, PingFang SC-Medium;
    font-weight: 500;
    color: #333333;
    line-height: 24px;
  }
}
</style>
